const TemplateListEmail = () => import('./pages/TemplateListEmail.vue')
const TemplateListSms = () => import('./pages/TemplateListSms.vue')
const TheContainer = () => import('../../containers/TheContainer')
const TemplateSmsCreate = () => import('./pages/TemplateSmsCreate')
const TemplateSmsEdit = () => import('./pages/TemplateSmsEdit')
const NewTemplateList = () => import('./pages/NewTemplateList')
const ImportHtml = () => import('./pages/ImportHtml')
const ImportHtmlConfimation = () => import('./pages/ImportHtmlConfimation')
const CreateSimpleHTML = () => import('./pages/CreateSimpleHTML')
const EditTemplateEmail = () => import('./pages/EditTemplateEmail')
const GrapesEditor = () => import('./pages/GrapesEditor')
const GrapesEditor2 = () => import('./pages/GrapesEditor2')

const templateRoutes = [
  {
    path: 'templates',
    component: TheContainer,
    children: [
      {
        path: 'emails',
        name: 'template-emails',
        component: TemplateListEmail,
      },
      {
        path: 'list-templates/:dynamicId?/:dynamicIndex?/:dynamicDestinationType?',
        name: 'new-template-list',
        component: NewTemplateList,
      },
      {
        path: 'import-html/:dynamicId?/:dynamicIndex?/:dynamicDestinationType?',
        name: 'import-html',
        component: ImportHtml,
      },
      {
        path: 'edit-template-html/:id/:dynamicId?/:dynamicIndex?/:dynamicDestinationType?',
        name: 'edit-template-html',
        component: EditTemplateEmail,
      },
      {
        path: 'import-confirm/:id/:dynamicId?/:dynamicIndex?/:dynamicDestinationType?',
        name: 'import-confirm',
        component: ImportHtmlConfimation,
      },
      {
        path: 'create-simple-text/:id?/:campaignId?/:indexChannel?/:contentType?',
        name: 'create-simple-text',
        component: CreateSimpleHTML,
      },
      {
        path: 'simple-text/:id?/:dynamicId?/:dynamicIndex?/:dynamicDestinationType?/:contentType?',
        name: 'simple-text',
        component: CreateSimpleHTML,
      },
      {
        path: 'sms',
        name: 'template-sms',
        component: TemplateListSms,
      },
      {
        path: 'sms/create',
        name: 'create-template-sms',
        component: TemplateSmsCreate,
      },
      {
        path: 'sms/edit/:id',
        name: 'edit-template-sms',
        component: TemplateSmsEdit,
      },
    ],
  },
  {
    path: 'email-builder/:id?/:campaignId?/:indexChannel?',
    name: 'email-builder',
    component: GrapesEditor,
  },
]

export default templateRoutes
